export function performanceLoggingSupported() {
    var performance = window.performance;
    return !!(performance &&
        performance.now &&
        performance.mark &&
        performance.timing &&
        performance.timing.navigationStart &&
        performance.measure &&
        performance.getEntriesByType);
}
//# sourceMappingURL=performanceLoggingSupported.js.map